"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValueInOptions = void 0;
const _ = require("lodash");
// Used to ensure unknown values are not passed and modified by an options input
function isValueInOptions(options, value) {
    const optionsArray = Array.isArray(options) ? options : [options];
    let valueArray = Array.isArray(value) ? value : [value];
    valueArray = valueArray.filter(x => (typeof x !== "string" || x !== "") && x !== undefined && x !== null);
    const optionValueArray = optionsArray.map(option => option.value);
    return _.difference(valueArray, optionValueArray).length === 0;
}
exports.isValueInOptions = isValueInOptions;
//# sourceMappingURL=isValueInOptions.js.map